/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/all',[
    'jquery',
    './Console',
    './Core',
    './CreditCard',
    './Data',
    './Forms',
    './HandlebarsUtils',
    './Logger',
    './Pagination',
    './UI/all',
    './Validation',
    './Constants',
    './EventBuilder',
    './EventManager',
    './RocAnalytics',
    './Geolocation',
    './UrlHelper',
    './OrderHelper',
    './ProductHelper',
    './LocalStorageHelper',
    './Extensions'
], function ($, Console, Core, CreditCard, Data, Forms, HandlebarsUtils, Logger, Pagination, UI, Validation, Constants, EventBuilder, EventManager, Tracker, Geolocation, UrlHelper, OrderHelper, ProductHelper, LocalStorageHelper, Extensions) {
    Logger.debug('Loaded ROC Global Dependencies');

    return {
        Core: Core,
        CreditCard: CreditCard,
        Data: Data,
        Forms: Forms,
        Logger: Logger,
        Pagination: Pagination,
        UI: UI,
        Validation: Validation,
        Events: Constants.events,
        Enums: Constants.enums,
        EventBuilder: EventBuilder,
        EventManager: EventManager,
        Tracker: Tracker,
        Geolocation: Geolocation,
        UrlHelper: UrlHelper,
        OrderHelper: OrderHelper,
        ProductHelper: ProductHelper,
        LocalStorageHelper: LocalStorageHelper,
        Extensions: Extensions
    };
});

